const homepageAnimateSelector = '[data-cc-animate]:not(.cc-animate-init)';
const homepageReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const homepageDesktopViewport = window.matchMedia('(min-width: 768px)');

let homepageAnimateObserver;
let homepageMutationTimer;

function revealHomepageElement(element) {
  element.classList.add('cc-animate-in');
  homepageAnimateObserver?.unobserve(element);
}

function initializeHomepageAnimations() {
  const elements = document.querySelectorAll(homepageAnimateSelector);
  if (!elements.length) return;

  elements.forEach((element) => {
    const animationName = element.dataset.ccAnimate;
    const animationDelay = element.dataset.ccAnimateDelay;
    const animationDuration = element.dataset.ccAnimateDuration;

    if (animationName) element.classList.add(animationName);
    if (animationDelay) element.style.setProperty('--aos-animate-delay', animationDelay);
    if (animationDuration) element.style.setProperty('--aos-animate-duration', animationDuration);

    element.classList.add('cc-animate-init');

    if (!homepageDesktopViewport.matches || homepageReducedMotion.matches || !homepageAnimateObserver) {
      revealHomepageElement(element);
      return;
    }

    homepageAnimateObserver.observe(element);
  });
}

function enableHomepageAnimations() {
  document.body.classList.add('homepage-animate-ready');

  if ('IntersectionObserver' in window && homepageDesktopViewport.matches && !homepageReducedMotion.matches) {
    homepageAnimateObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) revealHomepageElement(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
  }

  initializeHomepageAnimations();

  if ('MutationObserver' in window) {
    const mutationObserver = new MutationObserver(() => {
      window.clearTimeout(homepageMutationTimer);
      homepageMutationTimer = window.setTimeout(initializeHomepageAnimations, 120);
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', enableHomepageAnimations, { once: true });
} else {
  enableHomepageAnimations();
}

homepageDesktopViewport.addEventListener('change', () => {
  document.querySelectorAll('[data-cc-animate]').forEach((element) => revealHomepageElement(element));
  initializeHomepageAnimations();
});
